import { useResizeObserver } from './basler-components.es354.js';

let eventListenerInitialized = false;
function useViewport() {
  const setViewportWidth = () => {
    if (document) {
      const viewportWidthWithoutScrollbars = document.body.clientWidth / 100;
      document.documentElement.style.setProperty("--vw", `${viewportWidthWithoutScrollbars}px`);
    }
  };
  setViewportWidth();
  if (document && !eventListenerInitialized) {
    useResizeObserver(document.body, () => {
      setViewportWidth();
    });
    eventListenerInitialized = true;
  }
  return {
    setViewportWidth
  };
}

export { useViewport };
